import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { User } from '@upstart/harmony/lib/legos/userTypes';
import { Deal } from '@upstart/harmony/lib/legos/dealTypes';
import { dealerUsedInSession, dealUsedInSession, setUser } from './context';
import './start-rum';

interface DatadogRumProps {
  currentUser: User | null;
  currentDeal: Deal | null;
}

const DatadogRum: React.FC<DatadogRumProps> = ({
  currentUser,
  currentDeal,
}) => {
  useEffect(() => {
    const dealerId = currentUser?.dealer_id;
    if (dealerId !== undefined) {
      dealerUsedInSession(dealerId);
    }
  }, [currentUser?.dealer_id]);

  useEffect(() => {
    if (currentUser) {
      setUser(currentUser);
    }
  }, [currentUser]);

  useEffect(() => {
    if (currentDeal?.id) {
      dealUsedInSession(currentDeal?.id);
    }
  }, [currentDeal?.id]);

  return null;
};

const mapStateToProps = (state: any) => ({
  currentUser: state.user.currentUser,
  currentDeal: state.deals.deal,
});

export default connect(mapStateToProps)(DatadogRum);
